module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "nobottomborder no-sticky",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-wrap"
    }
  }, [_c('div', {
    staticClass: "container-fluid clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('router-link', {
    staticClass: "standard-logo",
    attrs: {
      "to": "/",
      "data-dark-logo": "./../assets/images/logo-media-dark.png"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/images/logo-media.png"),
      "alt": "Canvas Logo"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "retina-logo",
    attrs: {
      "to": "/",
      "data-dark-logo": "./../assets/images/logo-media-dark@2x.png"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/images/logo-media@2x.png"),
      "alt": "Canvas Logo"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "style-2",
    attrs: {
      "id": "primary-menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/portfolio"
    }
  }, [_vm._v("Portfolio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "primary-menu-trigger"
    }
  }, [_c('i', {
    staticClass: "icon-reorder"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-social-set"
  }, [_c('a', {
    staticClass: "social-icon si-small si-borderless si-facebook",
    attrs: {
      "href": "https://www.facebook.com/terri.a.swallow"
    }
  }, [_c('i', {
    staticClass: "icon-facebook"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-icon si-small si-borderless si-instagram",
    attrs: {
      "href": "https://www.instagram.com/terriann/"
    }
  }, [_c('i', {
    staticClass: "icon-instagram"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-instagram"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-icon si-small si-borderless si-linkedin",
    attrs: {
      "href": "https://www.linkedin.com/in/terriannswallow/"
    }
  }, [_c('i', {
    staticClass: "icon-linkedin"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-linkedin"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-icon si-small si-borderless si-github",
    attrs: {
      "href": "https://github.com/terriann"
    }
  }, [_c('i', {
    staticClass: "icon-github"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-github"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb59cf1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 110
// module chunks = 1